import type { To } from "react-router";

/** Where a Discover template opens, in the account's default brand tone when it has one. */
export const discoverTemplateLink = (
  template: { slug: string; program: { slug: string } },
  toneId?: string,
): To => ({
  pathname: `/discover/${template.program.slug}/${template.slug}`,
  ...(toneId ? { search: `?${new URLSearchParams({ tone: toneId }).toString()}` } : {}),
});
